export default __webpack_public_path__ + "static/media/icone-hora.838f1a76.svg";